import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { getDetailsdata } from '../../api'
import { insert_adv, remove_adv } from '../../method/addadv'
import { iframeLoad } from '../../method/analytics'
import img_home from '../../img_4/home.png'
import gameIcon from '../../img_4/h5_game.png'
import gameText from '../../img_4/H5GAME.png'
import './Details.css'
import starsScore from '../../method/start'
import getNum from '../../method/method'
import Footer from '../../components_4/Home/Footer/Footer'

export default function Details() {
  const [data, setData] = useState({})
  const [dataarr, setDataarr] = useState([])
  const [imgdata, setImgdata] = useState([])
  const { search } = useLocation()
  // console.log(search);

  // 跳转详情
  // const goDetails = (para) => {
  //     window.location = "/page/details?gid=" + para
  //     getdata("?gid=" + para)
  //     window.scrollTo(0, 0)
  // }

  // const playgame = (__url) => {
  //     window.location = __url
  // }

  useEffect(() => {
    const getdata = para => {
      getDetailsdata(para).then(res => {
        // console.log(res.data);
        setData(res.data)
        setDataarr(res.data.recommend)
        setImgdata(res.data.preview)
      })
    }

    getdata(search)

    if ((window.law_ntv_ad1, window.law_ntv_ad2)) {
      insert_adv('adv_1')
      insert_adv('adv_2')
      // 广告加载 上传分析
      var pageLoadSecond = new Date().getTime()
      iframeLoad(pageLoadSecond)

      return () => {
        remove_adv('adv_1')
        remove_adv('adv_2')
      }
    }
  }, [search])
  /* 返回上一页 */
  const goback = () => {
    window.location = '/'
  }

  return (
    <div className="details4">
      <div className="deta-head">
        <img src={img_home} alt="" onClick={goback} className="back_home" />
        <div className="page_tit">
          <img src={gameIcon} alt="" />
          <img src={gameText} alt="" />
        </div>
      </div>

      {/* 广告一 */}
      <div className="adv_box">
        <p>Advertisement</p>
        <div id="adv_1" dangerouslySetInnerHTML={{ __html: window.law_ntv_ad1 }}></div>
      </div>

      {/* 游戏详情 */}
      <div className="game_details">
        {/* name */}
        <h2>{data.name}</h2>
        <div className="de_title">
          {/* img_icon */}
          <img src={process.env.REACT_APP_BASEURL + data.icon} alt="" className="game_icon" />

          {/* download data */}
          <div className="load_de">
            <p className="score_start">
              {starsScore(data.score)} {data.score}
            </p>
            <span className="gametype">HotGame</span>
            <p className="load_count">
              <span>{getNum(data.count)}</span> player
            </p>
            {/* <p style={{ margin: '5px 0', color: 'blueviolet' }}>Author：{data.author}</p> */}
          </div>

          {/* gamebtn */}
          <div className="btn-box">
            <a href={data.link} className="dis_a">
              <button className="de-btn">PLAY</button>
            </a>
          </div>
          {/*<div className='btn-box'>*/}
          {/*    <button className='de-btn'>*/}
          {/*        <a href={data.link} className='dis_a'><i className="top"></i><i className="bottom"></i>*/}
          {/*            PLAY</a>*/}
          {/*    </button>*/}
          {/*</div>*/}
        </div>

        {/* description */}
        <h3 className="desc">Description</h3>
        <p className="desc_text">{data.description}</p>

        {/* gamedetails */}
        <h3>Preview</h3>
        <div className="game-preview">
          <div className="img-view">
            {imgdata?.map(item => (
              <img src={process.env.REACT_APP_BASEURL + item} key={item} alt="" /* onClick={() => img_dis(item)} */ className="list_img" />
            ))}
          </div>
        </div>
      </div>

      <div className="game_list">
        <h2>You might like.</h2>
        {/* 游戏列表区 */}
        <div>
          {dataarr?.map(item => (
            <div key={item.gid} className="list_item">
              <a href={'/page/details?gid=' + item.gid} className="dis_a">
                <img src={process.env.REACT_APP_BASEURL + item.icon} alt="" />

                <div className="item_con">
                  <h4>{item.name}</h4>
                  <p className="gamestart">
                    {starsScore(item.score)} {item.score}
                  </p>
                  <p className="playnum">{item.count / 1000}k+</p>
                </div>

                <div className="play">PLAY GAME</div>
              </a>
            </div>
          ))}
        </div>
      </div>

      {/* 广告二 */}
      <div className="adv_box">
        <p>Advertisement</p>
        <div id="adv_2" dangerouslySetInnerHTML={{ __html: window.law_ntv_ad2 }}></div>
      </div>

      <Footer></Footer>
    </div>
  )
}
